import { useBloc } from "@blac/react";
import React from "react";
import UserJourneyBloc from "src/ui/components/UserJourneyOverview/UserJourneyBloc";
import {
  DebugBadge,
  DebugButton,
  DebugButtonRow,
  DebugDivider,
  DebugKeyValue
} from "./debug.styles";

const DebugUserJourney = () => {
  const [{ enableAll, name, modules }, bloc] = useBloc(UserJourneyBloc);

  return (
    <div>
      <DebugKeyValue>
        <span className="key">Current Journey</span>
        <span className="value">{name || "—"}</span>
      </DebugKeyValue>
      <DebugKeyValue>
        <span className="key">All Steps Unlocked</span>
        <span className="value">
          <DebugBadge variant={enableAll ? "success" : "info"}>
            {enableAll ? "Yes" : "No"}
          </DebugBadge>
        </span>
      </DebugKeyValue>

      <DebugButtonRow style={{ marginTop: "0.75rem" }}>
        <DebugButton onClick={() => bloc.patch({ enableAll: !enableAll })}>
          {enableAll ? "Lock Steps" : "Unlock All Steps"}
        </DebugButton>
        <DebugButton onClick={() => bloc.patch({ journeyCardsVisible: true })}>
          Show Cards
        </DebugButton>
        <DebugButton onClick={() => bloc.patch({ journeyCardsLocked: true })}>
          Lock Cards
        </DebugButton>
      </DebugButtonRow>

      <DebugDivider />

      <details>
        <summary style={{ cursor: "pointer", fontSize: "12px", color: "#666" }}>
          Journey Modules ({modules?.length || 0})
        </summary>
        <pre
          style={{
            fontSize: "10px",
            background: "#f5f5f7",
            padding: "0.5rem",
            borderRadius: "4px",
            overflow: "auto",
            marginTop: "0.5rem"
          }}
        >
          {JSON.stringify(modules, null, 2)}
        </pre>
      </details>

      <details style={{ marginTop: "0.5rem" }}>
        <summary style={{ cursor: "pointer", fontSize: "12px", color: "#666" }}>
          Pending Tasks ({bloc.tasks?.length || 0})
        </summary>
        <pre
          style={{
            fontSize: "10px",
            background: "#f5f5f7",
            padding: "0.5rem",
            borderRadius: "4px",
            overflow: "auto",
            marginTop: "0.5rem"
          }}
        >
          {JSON.stringify(bloc.tasks, null, 2)}
        </pre>
      </details>
    </div>
  );
};

export default DebugUserJourney;
